<template>
  <ul class="accordion-list" :class="{ active: active }">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: "AccordionList",
  data: () => {
    return {
      active: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.accordion-list {
  &.-disabled {
    background-color: #cccccc;
  }
}
</style>
